export default "__VITE_ASSET__BRziLazl__"